import { useTranslation } from "react-i18next";

interface AspectProps {
  aspect: {
    id: string;
    text: string;
    visibility: "revealed" | "hidden";
  };
  isGM?: boolean;
}

export default function AspectCard({ aspect, isGM }: AspectProps) {
  const { t } = useTranslation();
  const show = isGM || aspect.visibility === "revealed";
  return (
    <span className="inline-block rounded border border-border bg-card px-2 py-1 text-sm">
      {show ? aspect.text : t("aspect.hidden")}
    </span>
  );
}
